var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneygramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 200,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.358 42.225 L 42.358 42.225 c -0.89 0.001 -1.597 0.445 -2.059 1.192 c 0.044 -0.845 -0.418 -1.093 -0.89 -1.093 c -0.224 0 -0.396 0.053 -0.408 0.085 l -0.964 5.532 c -0.097 0.575 0.225 0.737 0.631 0.737 h 0.173 c 0.45 0 0.633 -0.184 0.729 -0.737 l 0.578 -3.324 c 0.419 -0.735 0.88 -1.082 1.588 -1.082 c 0.718 0 1.137 0.433 1.157 1.147 c 0.011 0.184 -0.032 0.421 -0.074 0.694 l -0.451 2.565 c -0.096 0.575 0.225 0.737 0.633 0.737 h 0.172 c 0.45 0 0.633 -0.184 0.729 -0.737 l 0.494 -2.824 c 0.053 -0.316 0.096 -0.598 0.086 -0.845 C 44.439 43.07 43.656 42.225 42.358 42.225 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.48,45.17 37.48,45.17 37.48,45.17 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.42 42.226 c -2.148 0 -3.466 1.8 -3.401 3.776 c 0.066 1.8 1.275 2.957 3.056 2.957 c 2.204 0 3.467 -1.811 3.403 -3.788 C 37.422 43.479 36.3 42.226 34.42 42.226 z M 34.087 47.724 c -1.016 0 -1.65 -0.755 -1.685 -1.778 c -0.044 -1.321 0.799 -2.499 2.008 -2.499 c 0.928 0 1.663 0.755 1.694 1.788 C 36.148 46.637 35.295 47.724 34.087 47.724 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85.592 42.225 L 85.592 42.225 c -1.039 0.001 -1.732 0.552 -2.216 1.353 c -0.24 -0.844 -0.947 -1.352 -1.848 -1.352 c -0.788 0 -1.482 0.39 -1.954 1.115 c 0.021 -0.78 -0.421 -1.017 -0.872 -1.017 c -0.221 0 -0.379 0.053 -0.4 0.086 l -0.943 5.532 c -0.095 0.575 0.219 0.737 0.618 0.737 h 0.168 c 0.379 0 0.621 -0.162 0.715 -0.737 l 0.587 -3.432 c 0.431 -0.683 0.831 -0.974 1.471 -0.974 c 0.62 0 1.009 0.476 1.009 1.202 c 0 0.119 -0.011 0.249 -0.03 0.38 l -0.472 2.824 c -0.096 0.575 0.23 0.737 0.619 0.737 H 82.2 c 0.388 0 0.631 -0.174 0.726 -0.737 l 0.588 -3.432 c 0.431 -0.683 0.841 -0.974 1.471 -0.974 c 0.599 0 1.039 0.378 1.039 1.147 c 0 0.184 -0.03 0.421 -0.073 0.694 l -0.442 2.565 c -0.093 0.575 0.221 0.737 0.62 0.737 h 0.169 c 0.442 0 0.618 -0.184 0.712 -0.737 l 0.484 -2.824 c 0.053 -0.316 0.084 -0.598 0.084 -0.845 C 87.576 43.015 86.759 42.225 85.592 42.225 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.527 42.326 c -0.596 0 -0.926 0.3 -1.118 1.089 c -0.384 -0.745 -1.163 -1.189 -2.067 -1.189 c -1.929 0 -3.272 1.789 -3.272 3.822 c 0 1.677 0.99 2.911 2.546 2.911 c 0.949 0 1.686 -0.413 2.153 -1.234 c -0.064 0.856 0.097 1.123 0.684 1.123 c 0.533 0 0.703 -0.201 0.756 -0.812 c 0.073 -1.122 0.437 -2.954 0.864 -5.522 C 77.082 42.469 76.837 42.326 76.527 42.326 z M 72.946 47.724 c -0.937 0 -1.481 -0.623 -1.481 -1.723 c 0 -1.287 0.723 -2.577 2.067 -2.577 c 1.088 0 1.547 0.833 1.547 1.755 C 75.079 46.337 74.331 47.724 72.946 47.724 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.297 40.262 h -0.478 c -0.466 0 -0.667 0.144 -0.986 0.679 l -2.555 4.342 l -1.06 -4.298 c -0.128 -0.513 -0.266 -0.723 -0.796 -0.723 h -0.403 c -0.519 0 -0.859 0.323 -0.954 0.902 l -1.188 6.993 c -0.086 0.525 0.138 0.802 0.573 0.802 h 0.179 c 0.457 0 0.659 -0.233 0.743 -0.758 l 0.954 -5.657 l 0.923 3.786 c 0.075 0.378 0.15 0.635 0.839 0.635 c 0.583 0 0.721 -0.212 0.923 -0.567 l 2.258 -3.899 l -0.954 5.658 c -0.086 0.534 0.138 0.802 0.562 0.802 h 0.191 c 0.456 0 0.657 -0.245 0.742 -0.758 l 1.188 -7.015 C 31.092 40.629 30.838 40.262 30.297 40.262 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.461 47.566 c -0.002 -0.189 -0.115 -0.291 -0.33 -0.291 h -0.229 c -0.052 0 -0.087 0.034 -0.095 0.099 l -0.153 0.933 c -0.009 0.057 0.013 0.089 0.054 0.089 h 0.021 c 0.043 0 0.062 -0.027 0.073 -0.082 l 0.059 -0.359 h 0.114 l 0.128 0.264 c 0.07 0.146 0.111 0.179 0.176 0.179 c 0.108 0 0.1 -0.106 0.096 -0.109 c -0.066 -0.001 -0.092 -0.038 -0.138 -0.128 h 0 l -0.112 -0.218 C 89.34 47.934 89.465 47.792 89.461 47.566 z M 89.095 47.814 h -0.213 l 0.065 -0.393 h 0.174 c 0.12 0 0.186 0.056 0.188 0.162 C 89.312 47.726 89.234 47.814 89.095 47.814 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.632 42.226 c -2.658 0 -3.61 2.072 -3.61 3.878 c 0 1.716 1.17 2.855 2.971 2.855 s 2.815 -0.85 2.815 -1.526 c 0 -0.455 -0.303 -0.611 -0.649 -0.643 c -0.469 0.643 -1.13 0.952 -2.018 0.952 c -0.786 0 -1.726 -0.32 -1.789 -1.805 h 4.089 c 0.44 0 0.775 -0.266 0.775 -0.852 c 0 -0.876 -0.166 -1.463 -0.544 -1.973 C 50.264 42.558 49.511 42.226 48.632 42.226 z M 46.497 44.873 c 0.323 -0.919 1.079 -1.483 2.042 -1.483 c 0.481 0 0.858 0.144 1.1 0.431 c 0.206 0.254 0.292 0.609 0.26 1.052 H 46.497 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.299 44.054 h -2.483 c -0.296 0 -0.436 0.066 -0.532 0.166 c -0.15 0.164 -0.225 0.535 -0.225 0.7 c 0.009 0.263 0.234 0.415 0.631 0.415 h 1.763 c -0.246 1.26 -1.026 2.136 -2.373 2.136 c -1.411 0 -2.364 -0.921 -2.418 -2.484 c -0.064 -1.972 1.209 -3.592 3.016 -3.592 c 1.057 0 1.881 0.58 2.225 1.346 c 0.042 0.054 1.025 0.054 0.994 -0.8 c -0.01 -0.306 -0.181 -0.668 -0.503 -0.974 c -0.523 -0.526 -1.496 -0.986 -2.789 -0.986 c -1.818 0 -3.252 1.029 -3.999 2.507 c 0 -0.011 -0.012 -0.011 -0.012 -0.011 c -0.149 -0.198 -0.395 -0.296 -0.631 -0.296 c -0.406 0 -0.662 0.132 -1.057 0.833 l -1.936 3.47 l -0.729 -3.46 c -0.137 -0.646 -0.364 -0.842 -0.769 -0.842 c -0.47 0 -0.855 0.35 -0.834 0.437 l 1.38 5.597 l -1.444 2.386 c -0.148 0.262 -0.161 0.601 0.386 0.601 h 0.299 c 0.565 0 0.748 -0.351 1.026 -0.833 l 3.892 -6.733 c -0.121 0.487 -0.172 0.989 -0.15 1.49 c 0.075 2.266 1.561 3.623 3.744 3.623 c 1.036 0 1.859 -0.404 2.319 -1.018 c -0.033 0.656 0.31 0.921 0.77 0.921 c 0.257 0 0.438 -0.087 0.438 -0.131 l 0.63 -3.625 C 65.025 44.339 64.821 44.054 64.299 44.054 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.289 42.226 c -0.707 0 -1.227 0.421 -1.591 1.191 c 0.052 -0.845 -0.393 -1.093 -0.851 -1.093 c -0.23 0 -0.384 0.053 -0.396 0.085 l -0.945 5.532 c -0.093 0.575 0.27 0.737 0.666 0.737 h 0.166 c 0.375 0 0.562 -0.184 0.656 -0.737 l 0.311 -1.851 c 0.24 -1.439 0.748 -2.448 1.578 -2.448 c 0.406 0 0.656 0.175 0.833 0.369 c 0.02 0.022 0.643 -0.227 0.623 -0.996 C 70.319 42.539 69.86 42.226 69.289 42.226 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.057 46.995 c -0.52 0 -0.942 0.441 -0.942 0.982 c 0 0.541 0.422 0.982 0.942 0.982 c 0.52 0 0.943 -0.44 0.943 -0.982 C 90 47.436 89.577 46.995 89.057 46.995 z M 89.057 48.819 c -0.447 0 -0.809 -0.378 -0.809 -0.843 c 0 -0.465 0.362 -0.843 0.809 -0.843 c 0.448 0 0.809 0.378 0.809 0.843 C 89.866 48.442 89.505 48.819 89.057 48.819 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.274,
    cy: 45.004,
    r: 9.274,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.547 45 c 0 5.122 -4.152 9.274 -9.274 9.274 S 0 50.122 0 45 c 0 -1.411 0.315 -2.748 0.879 -3.945 c -0.376 0.951 -0.544 1.893 -0.544 2.775 c 0 4.199 3.39 4.807 4.833 4.793 c 2.193 -0.02 4.756 -1.094 6.915 -3.084 l -0.364 2.047 c -0.081 0.468 0.225 0.88 0.692 0.883 h 0.193 c 0.485 0 0.829 -0.395 0.917 -0.883 l 0.778 -4.376 c 0.093 -0.486 -0.227 -0.881 -0.712 -0.881 H 9.203 c -0.488 0 -0.933 0.258 -1.02 0.748 l -0.034 0.197 c -0.07 0.466 0.255 0.817 0.72 0.817 h 2.287 c -0.037 0.035 -0.073 0.071 -0.109 0.107 c -1.577 1.492 -3.521 2.309 -5.132 2.309 c -1.608 0 -3.408 -1.014 -3.408 -3.299 c 0 -4.736 4.442 -7.483 6.768 -7.483 C 14.385 35.726 18.547 39.878 18.547 45",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(218,41,28)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneygramLogo);
export default __webpack_public_path__ + "static/media/moneygram-logo.6351125ddf9da0b25aceaf1df3d43b80.svg";
export { ForwardRef as ReactComponent };